module.exports = require('next/error')
